import { addScriptOn } from '../Utils/script'

export function setupAbsoluteLabs(absoluteLabsScriptURL: string, absoluteLabsSiteId: string) {
	if (document.head.querySelector('#absoluteLabsScript')) {
		return Promise.reject('Absolute Labs script already exists')
	}

	return Promise.all([
		addScriptOn(document.head, {
			src: absoluteLabsScriptURL,
			id: 'absoluteLabsScript'
		}),
		addScriptOn(document.head, {
			textContent: `
                window.ALSDK = window.ALSDK || {detectWallet:async()=>{return new Promise(async(resolve)=>{document.addEventListener('absolutelabs.walletDetected',(e)=>{resolve(e.detail)})})}};
                ALSDK.siteId = '${absoluteLabsSiteId}';
            `,
			id: 'absoluteLabsSetupScript'
		})
	])
}
